export default "__VITE_ASSET__BtVYCXBR__"